// @copyright  2006-2023 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/projects/projects/archive',
        component: () =>
            import('@/pages/[organisation]/projects/projects/archive.vue'),
        name: 'project-management.projects.archived-projects',
        meta: {
            loginRequired: true,
            permission: 'access.project.project.update-project',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/projects/projects/archive/[id].vue'),
                name: 'project-management.projects.view-archived-project',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project.update-project',
                },
            },
        ],
    },

    {
        path: '/:organisation/projects/projects/bin',
        component: () =>
            import('@/pages/[organisation]/projects/projects/bin.vue'),
        name: 'project-management.projects.binned-projects',
        meta: {
            loginRequired: true,
            permission: 'access.project.project.archive-projects',
        },
        children: [
            {
                path: ':id',
                component: () =>
                    import('@/pages/[organisation]/projects/projects/bin/[id].vue'),
                name: 'project-management.projects.view-binned-project',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project.archive-projects',
                },
            },
        ],
    },

    {
        path: '/:organisation/projects/projects',
        component: () =>
            import('@/pages/[organisation]/projects/projects.vue'),
        name: 'project-management.projects.search-projects',
        meta: {
            loginRequired: true,
            permission: 'access.project.project.view-projects',
        },

        children: [
            {
                path: 'new',
                component: () =>
                    import('@/pages/[organisation]/projects/projects/new.vue'),
                name: 'project-management.projects.create-project',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project.create-project',
                },
            },
            {
                path: ':id',
                component: () =>
                    import(/* webpackChunkName: "project-management.projects" */ '@/pages/[organisation]/projects/projects/[id].vue'),
                name: 'project-management.projects.view-project',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project.view-projects',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import(/* webpackChunkName: "project-management.projects" */ '@/pages/[organisation]/projects/projects/[id]/edit.vue'),
                name: 'project-management.projects.update-project',
                meta: {
                    loginRequired: true,
                    permission: 'access.project.project.update-project',
                },
            },
        ],
    },
];
